import React, { useState } from 'react';
import { requestMagicLink } from '../api/accountPortalClient.js';
import { phMagicLinkRequestFailed } from '../utils/posthogEvents.js';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [result, setResult] = useState(null);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      const data = await requestMagicLink(email.trim().toLowerCase());
      setResult(data);
      if (data?.reason === 'no_portal_access' || data?.reason === 'rate_limited') {
        phMagicLinkRequestFailed({ reason: data.reason });
      }
    } catch (err) {
      setError(err?.message || 'Failed to send link');
      phMagicLinkRequestFailed({ reason: 'request_error' });
    } finally {
      setSubmitting(false);
    }
  }

  function resetForm() {
    setResult(null);
    setError('');
  }

  return (
    <div className="page">
      <div className="card">
        <h1 className="logo">CODiii</h1>
        <p className="subtitle">Sign in to manage licenses, users, and billing for your organization.</p>

        {error && <div className="alert alert-error">{error}</div>}
        {result?.sent ? (
          <div className="alert alert-success">
            We sent a sign-in link to <strong>{email}</strong>. Check your inbox and spam folder.
          </div>
        ) : result?.reason === 'no_portal_access' ? (
          <div className="alert alert-warning">
            You do not have access to license management. Please contact your software provider at{' '}
            <a href="mailto:support@codiii.com">support@codiii.com</a> for access.
          </div>
        ) : result?.reason === 'rate_limited' ? (
          <div className="alert alert-error">{result.message}</div>
        ) : !result ? (
          <form onSubmit={handleSubmit}>
            <div className="field">
              <label htmlFor="email">Work email</label>
              <input
                id="email"
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@company.com"
                disabled={submitting}
              />
            </div>
            <button className="btn" type="submit" disabled={submitting || !email.trim()}>
              {submitting ? 'Sending…' : 'Email me a sign-in link'}
            </button>
          </form>
        ) : null}

        <p className="subtitle" style={{ marginTop: 24, marginBottom: 0, fontSize: 13 }}>
          Product users sign in at{' '}
          <a href={import.meta.env.VITE_APP_PRODUCT_URL || 'https://app.codiii.com'}>app.codiii.com</a>.
        </p>
        {result && (
          <p style={{ marginTop: 16 }}>
            <button type="button" className="link-button" onClick={resetForm}>
              Use a different email
            </button>
          </p>
        )}
      </div>
    </div>
  );
}
